import React from 'react';
import PropTypes from 'prop-types';
import { Input as AntInput } from 'antd';
import styles from './input.module.scss';

// Polje forme sa labelom iznad - isti izgled kao antd Select polja u modalima
// (labela + kontrola), a sama kontrola je obican antd Input.
const Input = ({ label, id, type, className, ...rest }) => {
  const Field = type === 'password' ? AntInput.Password : AntInput;

  return (
    <div className={`${styles.field} ${className || ''}`}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
      <Field id={id} type={type === 'password' ? undefined : type} {...rest} />
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.node,
  id: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
};

export default Input;
